export const drawersConfig = [
    { id: 'cart', title: 'cart', emptyMessage: 'cart_empty', open: false },
    { id: 'favorites', title: 'favorites', emptyMessage: 'favorites_empty', open: false },
    { id: 'comparison', title: 'comparison', emptyMessage: 'comparison_empty', open: false },
];
